export default "/_next/static/fonts/tt_norms_pro_light-7f38b08bf2d748a4c3c6c6db46f2e867.woff";